import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import fetchWhatsAppList from '../../utils/whatsapp-util';
import { getCurrentOrganization } from '../../utils/helpers';

function normalizeSlug(slug = '') {
  return slug.replace(/^\/|\/$/g, '');
}

const HIDDEN_PATHS = ['/prep', '/open-mock-test', '/lp/enquiry', 'lp/advanced-scholarship'];

export default function FloatingContactButtons({
  apiName = 'whats-url-list',
  language = 'en',
}) {
  const router = useRouter();

  const [phoneNumber, setPhoneNumber] = useState('');
  const [whatsappNumber, setWhatsappNumber] = useState(null);
  const [isNextias, setIsNextias] = useState(false);
  const [hideIcons, setHideIcons] = useState(false);
  const [currentSlug, setCurrentSlug] = useState(null);
  // const [showScrollTop, setShowScrollTop] = useState(false);

  // useEffect(() => {
  //   const onScroll = () => {
  //     setShowScrollTop(window.scrollY > 300);
  //   };

  //   window.addEventListener('scroll', onScroll);
  //   return () => window.removeEventListener('scroll', onScroll);
  // }, []);

  useEffect(() => {
    if (!router.isReady) return undefined;

    const domain = getCurrentOrganization();
    setIsNextias(domain?.organizationName === 'nextias');

    const { href } = window.location;
    setHideIcons(HIDDEN_PATHS.some((p) => href.includes(p)));

    const path = router.asPath;

    if (path.includes('/centres/jaipur')) {
      setPhoneNumber('9358200522');
    } else if (path.includes('/centres/prayagraj')) {
      setPhoneNumber('9958857757');
    } else {
      setPhoneNumber('8081300200');
    }

    const slug = router.asPath
      .split('?')[0]
      .split('#')[0]
      .replace(/^\//, '');

    setCurrentSlug(slug);

    return undefined;
  }, [router.isReady, router.asPath]);

  useEffect(() => {
    let cancelled = false;

    if (!router.isReady || !isNextias || hideIcons) {
      return undefined;
    }

    const resolveWhatsApp = async () => {
      try {
        setWhatsappNumber(null);

        const list = await fetchWhatsAppList(apiName, language);

        const match = list.find(
          (item) => normalizeSlug(item.slug) === normalizeSlug(currentSlug),
        );

        if (!cancelled && match?.phone) {
          setWhatsappNumber(match.phone);
        }
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('Error fetching WhatsApp list:', err);
        }
      }
    };

    resolveWhatsApp();

    return () => {
      cancelled = true;
    };
  }, [router.isReady, isNextias, currentSlug, hideIcons, apiName, language]);

  if (hideIcons || !isNextias) {
    return null;
  }

  return (
    <div
      id="waCallWrapper"
      className="fixed bottom-14 left-2 z-[9999] flex flex-col items-center"
    >
      {phoneNumber && (
        <div className="group relative mb-2 flex h-[34px] w-[34px] items-center justify-center rounded-full bg-[#005ba5] shadow-md">
          <a href="tel:8081300200" aria-label="Call us">
            <img
              src="https://cdnstatic.nextias.com//phone-svgrepo-com-1756984196667.svg"
              width="25"
              height="25"
              alt="Call"
            />
          </a>
          <span className="pointer-events-none absolute left-full top-1/2 ml-2 -translate-y-1/2 rounded bg-black px-2 py-0.5 text-xs text-white opacity-0 transition group-hover:opacity-100">
            Call
          </span>
        </div>
      )}

      {whatsappNumber && (
        <a
          href={`https://wa.me/${whatsappNumber}`}
          target="_blank"
          rel="noreferrer"
          aria-label="Chat on WhatsApp"
          className="group relative"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            width="40"
            height="40"
            alt="WhatsApp"
          />
          <span className="pointer-events-none absolute left-full top-1/2 ml-2 -translate-y-1/2 rounded bg-black px-2 py-0.5 text-xs text-white opacity-0 transition group-hover:opacity-100">
            WhatsApp
          </span>
        </a>
      )}

      {/* {showScrollTop && (
        <button
          type="button"
          aria-label="Scroll to top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="to-top fixed bottom-30 right-4 z-[9999] flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-md hover:shadow-lg border-2 border-red-500"
        >
          <img
            src="https://cdnstatic.nextias.com/assets/images/icons/arrow-up.svg"
            alt="Scroll to top"
            width="18"
            height="18"
          />
        </button>
      )} */}
    </div>
  );
}

FloatingContactButtons.propTypes = {
  apiName: PropTypes.string,
  language: PropTypes.string,
};
